const IsCorporateUser = (userId: string | undefined) => {
  if (!userId) return false;
  return userId?.length < 11;
};

export default IsCorporateUser;
